export function required(value) {
  if (!value) {
    return "required";
  }

  return undefined;
}

export function matches(fieldName) {
  return (val, values) => {
    if (val !== values[fieldName]) {
      return "mismatch";
    }

    return undefined;
  };
}

export function numeric(n) {
  if (isNaN(parseFloat(n)) || !isFinite(n)) {
    return "expected_numeric";
  }
  return undefined;
}



// WEBPACK FOOTER //
// ./app/lib/validate-this/rules.js